import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Topbar from "./Topbar";
import "../styles/layout.css";
import { AnimatePresence, motion } from "framer-motion";
import { socket } from "../socket";

export default function AppLayout({ user, setUser }) {
  const location = useLocation();

  useEffect(() => {
    const uid = user?.id || user?._id;
    if (!uid) return;

    if (!socket.connected) socket.connect();
    socket.emit("join", { userId: uid });
  }, [user?.id, user?._id]);

  // Per-role theming: drive the accent palette off the signed-in role while the
  // dashboard is mounted; clear it on exit so public pages keep the violet brand.
  useEffect(() => {
    const role = user?.role;
    if (role) document.documentElement.setAttribute("data-role", role);
    return () => document.documentElement.removeAttribute("data-role");
  }, [user?.role]);

  return (
    <div className="app-layout-shell">
      <div className="app-layout-bg-orb orb-a" />
      <div className="app-layout-bg-orb orb-b" />
      <div className="app-layout-bg-grid" />

      <div className="app-layout">
        <div className="app-main-shell">
          <Topbar
            user={user}
            setUser={setUser}
          />

          <AnimatePresence mode="wait">
            <motion.main
              key={location.pathname}
              className="main"
              initial={{ opacity: 0, y: 16, scale: 0.995 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -8, scale: 0.995 }}
              transition={{ duration: 0.24, ease: "easeOut" }}
            >
              <Outlet />
            </motion.main>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}